import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Lock, Trophy } from "lucide-react";
import { useNavigate } from "react-router-dom";
import UnifiedPortalHeader from "@/components/UnifiedPortalHeader";
import SharedFooter from "@/components/SharedFooter";

export function FeatureLockedView({ upgradeMessage }) {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      {/* Global Header - no back button */}
      <UnifiedPortalHeader
        portalType="student"
        userName=""
        userSubtitle=""
        onLogout={() => navigate("/student/profile")}
        showUserInfo={false}
        showHomeButton={false}
        hideLogout={true}
      />

      <main className="max-w-4xl mx-auto px-4 py-8 flex-1">
        <Card className="border-0 shadow-lg">
          <CardContent className="pt-8 pb-8 text-center">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Lock className="w-10 h-10 text-amber-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Premium Feature
            </h2>
            <p className="text-gray-600 mb-6 max-w-md mx-auto">
              {upgradeMessage || "Practice Tests are available on Plus and Pro plans. Upgrade to access timed tests and track your progress!"}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                className="bg-gradient-to-r from-emerald-600 to-teal-600"
                onClick={() => navigate("/parent/dashboard")}
                data-testid="upgrade-btn"
              >
                <Trophy className="w-4 h-4 mr-2" />
                Upgrade Plan
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate("/student/profile")}
              >
                Back to Profile
              </Button>
            </div>
          </CardContent>
        </Card>
      </main>

      {/* Global Footer */}
      <SharedFooter />
    </div>
  );
}

export default FeatureLockedView;
